import Head from 'next/head';
import {useRouter} from 'next/router';

import {HeadSEO, useCanonicalUrl} from '@udemy/head-seo';
import {useI18n} from '@udemy/i18n';
import {META_DEFAULT_BASE_URL} from '@udemy/nextjs-core';

import {getDemoFormLayout} from 'src/components/layout/demo-form-layout';

import {DemoFormBody} from './demo-form-body.react-component';

export const DemoFormFeature = () => {
    const router = useRouter();
    const {url: canonicalUrl} = useCanonicalUrl(
        router as {locale: string; asPath: string},
        [],
        META_DEFAULT_BASE_URL,
    );
    const {gettext} = useI18n();

    const META_PROPS = {
        seoTitle: gettext('Contact Sales and Request a Demo | Udemy'),
        seoDescription: gettext(
            'Schedule a live demo to see how Udemy’s integrated learning solution can boost skills and innovation for your organization. We’re ready to answer your questions and to build a plan that meets your needs.',
        ),
    };

    return (
        <>
            <HeadSEO
                title={META_PROPS.seoTitle}
                ogTitle={META_PROPS.seoTitle}
                description={META_PROPS.seoDescription}
                ogDescription={META_PROPS.seoDescription}
                ogType={'website'}
                ogLocale={process.env.I18N_PATH_TO_BUNDLE_MAP[router.locale]}
                canonicalUrl={canonicalUrl}
                assetPath={process.env.ASSET_PREFIX}
                robots={['index', 'follow']}
                headWrapper={Head}
            />
            <DemoFormBody />;
        </>
    );
};

DemoFormFeature.getLayout = getDemoFormLayout;
